<div class="dropdown" ngbDropdown [placement]="placement">
  <button
    [class]="buttonClasses"
    type="button"
    [id]="dropdownId"
    [disabled]="disabled"
    ngbDropdownToggle
    [ngbTooltip]="tooltipText ? (tooltipText | translate) : null"
    [class.dropdown-toggle]="false"
  >
    @if (buttonIcon) {
    <i [class]="buttonIcon"></i>
    } @if (buttonText) {
    <span [class]="buttonIcon ? 'ms-1' : ''">{{ buttonText | translate }}</span>
    }
  </button>

  <div
    class="dropdown-menu"
    ngbDropdownMenu
    [attr.aria-labelledby]="dropdownId"
  >
    @for (option of options; track $index) { @if (option.divider) {
    <div class="dropdown-divider"></div>
    } @else {
    <button
      class="dropdown-item"
      [class.disabled]="option.disabled"
      type="button"
      [disabled]="option.disabled"
      [ngbTooltip]="option.tooltip ? (option.tooltip | translate) : null"
      (click)="onOptionClick(option)"
    >
      @if (option.icon) {
      <i [class]="option.icon + ' me-2 ' + (option.iconClass || '')"></i>
      }
      {{ option.label | translate }}
    </button>
    } }
  </div>
</div>
